<template>
  <div class="wper hper pr">
    <input type="file" class="pa top50 left10" @input="onInput" />
    <a-button class="pa top100 left10" @click="a">test</a-button>
    <a-upload
      class="pa top10 left10"
      name="file"
      :fileList="fileList"
      :data="{ }"
      @change="(val) => { handleChange(val) }"
    >
      <a-button> <a-icon type="upload" />点击上传</a-button>
    </a-upload>
    <div id="mindMapContainer" class="wper hper" />
  </div>
</template>
<script>
  import MindMap from "simple-mind-map"
  // import KeyboardNavigation from 'simple-mind-map/src/plugins/KeyboardNavigation.js'
  import xmind from 'simple-mind-map/src/parse/xmind.js'
  export default {
    data() {
      return {
        fileList: [],
        mindMap: null
      }
    },
    mounted() {
      this.mindMap = new MindMap({
        // 提供一个宽高不为0的容器元素
        el: document.getElementById('mindMapContainer'),
        // 思维导图数据
        data: {
          "data": {
            // 节点文本
            text: '根节点',
          },
          "children": []
        },
        readonly: true
      })
      // mindMap.usePlugin(KeyboardNavigation)
      // mindMap.execCommand('INSERT_NODE')
    },
    methods: {
      async a() {
        try {
          const url = 'http://demo.dyboke.cn/a.xmind'
          const res = await fetch(url)
          console.log('res', res)
          const file = await res.blob()
          const data = {
            raw: file
          }
          await this.handleChange(data)
        } finally {

        }
      },
      async handleChange(e) {
        try {
          console.log(e)
          let data = await xmind.parseXmindFile(e.raw)
          console.log(data)
          if (data.root) {
            this.mindMap.setFullData(data)
          } else {
            this.mindMap.setData(data)
          }
          this.mindMap.view.reset()
        } finally {

        }
      },
      async onInput(e) {
        console.log(e.target.files[0])
        let data = await xmind.parseXmindFile(e.target.files[0])
        if (data.root) {
          this.mindMap.setFullData(data)
        } else {
          this.mindMap.setData(data)
        }
        this.mindMap.view.reset()
      }
    }
  }
</script>